import type { Locale } from '@simsm/shared-types';

export const SUPPORTED_LOCALES: readonly Locale[] = ['en', 'ro', 'ru'] as const;

export const DEFAULT_LOCALE: Locale = 'ro';

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  ro: 'Română',
  ru: 'Русский',
};

/**
 * The gov.md strip writes the languages as two-letter codes, not full names:
 * MUD's own `.top-section` draws `Ro · Ru · En` with the active one underlined
 * (Components file `KB1Z6GHjOhHw3QL8ki9Mn6`, node `1144:15205`), and the
 * wireframe's `.lang` buttons agree (`Autentificare.tsx:38`). Menus keep
 * `LOCALE_LABELS` — a list has room for the whole word, a 32px strip does not.
 *
 * These are proper nouns in each language's own script, not translated copy, so
 * they are declared here rather than in the i18n catalogues — same reasoning as
 * `LOCALE_LABELS` above.
 */
export const LOCALE_CODE_LABELS: Record<Locale, string> = {
  en: 'En',
  ro: 'Ro',
  ru: 'Ru',
};
